/*
 * @Date: 2022-11-21 14:08:13
 * @LastEditors: huguochi zheng@sense.sg
 * @LastEditTime: 2025-10-27 10:28:40
 * @FilePath: /nicee-h5/src/router-activities.js
 * @Description:
 */

const routers = [
  // // 世界杯活动
  // {
  //   path: '/world-cup',
  //   name: 'worldCup',
  //   component: () => import('./activities/world-cup/index.vue')
  // },
  // // 聖誕節活動
  // {
  //   path: '/christmas',
  //   name: 'Christmas',
  //   component: () => import('./activities/christmas/index.vue')
  // },
  // // 聖誕節活動開獎
  // {
  //   path: '/christmas-draw',
  //   name: 'ChristmasDraw',
  //   component: () => import('./activities/christmas-draw/index.vue')
  // },
  // // 元旦节活動
  // {
  //   path: '/new-year',
  //   name: 'newYear',
  //   component: () => import('./activities/new-year/index.vue')
  // },
  // {
  //   path: '/spring-festival',
  //   name: 'springFestival',
  //   component: () => import('./activities/spring-festival/index.vue')
  // },
  // // 情人節活動
  // {
  //   path: '/valentine-day-2023',
  //   name: 'valentineDay2023',
  //   component: () => import('./activities/valentine-day2/index.vue')
  // },
  // // 情人節活動
  // {
  //   path: '/valentine-day-0314',
  //   name: 'WhitevalentineDay',
  //   component: () => import('./activities/white-valentine-day/index.vue')
  // },
  // // 语音房告解联合活动
  // {
  //   path: '/voice-room-confess',
  //   name: 'voiceRoomConfess',
  //   component: () => import('./activities/voice-room-confess/index.vue')
  // },
  // // 爱心活动
  // {
  //   path: '/love',
  //   name: 'Love',
  //   component: () => import('./activities/love/index.vue')
  // },
  // // 520活动
  // {
  //   path: '/love520',
  //   name: 'Love520',
  //   component: () => import('./activities/love-520/index.vue')
  // },
  {
    path: '/aPullc2025',
    name: 'APullC2025',
    redirect: '/aPullc'
  },
  {
    path: '/aPullc',
    name: 'APullC',
    component: () => import('./activities/aPullc2025/index.vue')
  },
  // A拉c宣传页
  {
    path: '/apullc-activity-2025',
    name: 'APullCActivity2025',
    redirect: '/apullc-activity'
  },
  // A拉c宣传页
  {
    path: '/apullc-activity',
    name: 'APullCActivity',
    component: () => import('./activities/aPullc2025/activity.vue')
  },
  // A拉c绑定成功
  {
    path: '/apullc-bind-success',
    name: 'APullCBindSuccess',
    component: () => import('./activities/aPullc2025/bind-code-success.vue')
  },
  // // 积分排名活动
  // {
  //   path: '/score-board',
  //   name: 'Scoreboard',
  //   component: () => import('./activities/score-board/index.vue')
  // },
  // 糖果排名活动
  // {
  //   path: '/candies-draw2',
  //   name: 'CandiesDraw2',
  //   component: () => import('./activities/candies-draw/index.vue')
  // },
  // // 618活动
  // {
  //   path: '/activity618',
  //   name: 'Activity618',
  //   component: () => import('./activities/activity618/index.vue')
  // },
  // // 端午节活动
  // {
  //   path: '/dragon-boat2',
  //   name: 'DragonBoat2',
  //   component: () => import('./activities/dragon-boat2/index.vue')
  // },
  // // 积分二期排名活动
  // {
  //   path: '/score-board2',
  //   name: 'Scoreboard2',
  //   component: () => import('./activities/score-board2/index.vue')
  // },
  // // 爱心活动
  // {
  //   path: '/love-714',
  //   name: 'Love714',
  //   component: () => import('./activities/love-714/index.vue')
  // },
  // // 语音房以歌声入人心活动
  // {
  //   path: '/voice-room-avatar',
  //   name: 'VoiceRoomAvatar',
  //   component: () => import('./activities/voice-room-avatar/index.vue')
  // },
  // 糖果排名活动
  // {
  //   path: '/candies-draw3',
  //   name: 'CandiesDraw3',
  //   component: () => import('./activities/candies-draw3/index.vue')
  // },
  // 糖果4期排名活动
  // {
  //   path: '/candies-draw4',
  //   name: 'CandiesDraw4',
  //   component: () => import('./activities/candies-draw4/index.vue')
  // },
  // // 綠色情人節
  // {
  //   path: '/green-valentine-day',
  //   name: 'GreenValentineDay',
  //   component: () => import('./activities/green-valentine-day/index.vue')
  // },
  // // 七夕情人節
  // {
  //   path: '/valentine-day-qixi',
  //   name: 'ValentineDayQixi',
  //   component: () => import('./activities/valentine-day-qixi/index.vue')
  // },
  // // 积分三期排名活动
  // {
  //   path: '/score-board3',
  //   name: 'Scoreboard3',
  //   component: () => import('./activities/score-board3/index.vue')
  // },
  // // 头像框-听歌开小火箭
  // {
  //   path: '/avatar-frame-rocket',
  //   name: 'AvatarFrameRocket',
  //   component: () => import('./activities/avatar-frame-rocket/index.vue')
  // },
  // // 中秋节
  // {
  //   path: '/moon-festival',
  //   name: 'MoonFestival',
  //   component: () => import('./activities/moon-festival/index.vue')
  // },
  // // 积分四期排名活动（神魔）
  // {
  //   path: '/score-board4',
  //   name: 'Scoreboard4',
  //   component: () => import('./activities/score-board4/index.vue')
  // },
  // // 双十活动
  // {
  //   path: '/national-day',
  //   name: 'NationlDay',
  //   component: () => import('./activities/national-day/index.vue')
  // },
  // 糖果5期排名活动
  // {
  //   path: '/candies-draw5',
  //   name: 'CandiesDraw5',
  //   component: () => import('./activities/candies-draw5/index.vue')
  // },
  // // 聖誕節活動
  // {
  //   path: '/christmas2',
  //   name: 'Christmas2',
  //   component: () => import('./activities/christmas2/index.vue')
  // },
  // // 星座活動
  // {
  //   path: '/constellation',
  //   name: 'Constellation',
  //   component: () => import('./activities/constellation/index.vue')
  // },
  // // 积分五期排名活动（深海積分賽）
  // {
  //   path: '/score-board5',
  //   name: 'Scoreboard5',
  //   component: () => import('./activities/score-board5/index.vue')
  // },
  // // 开宝箱活动（橙色狂歡）
  // {
  //   path: '/orange-valentine-day',
  //   name: 'OrangeValentineDay',
  //   component: () => import('./activities/orange-valentine-day/index.vue')
  // },
  // // 积分6期排名活动（寵愛積分賽）
  // {
  //   path: '/score-board6',
  //   name: 'Scoreboard6',
  //   component: () => import('./activities/score-board6/index.vue')
  // },
  // // 星座活動(射手座)
  // {
  //   path: '/constellation2',
  //   name: 'Constellation2',
  //   component: () => import('./activities/constellation2/index.vue')
  // },
  // 糖果6期活动
  // {
  //   path: '/candies-draw6',
  //   name: 'CandiesDraw6',
  //   component: () => import('./activities/candies-draw6/index.vue')
  // },
  // 传奇商店
  {
    path: '/legendary-store',
    name: 'LegendaryStore',
    component: () => import('./activities/legendary-store/index.vue')
  },
  // // 聖誕節
  // {
  //   path: '/christmas3',
  //   name: 'Christmas3',
  //   component: () => import('./activities/christmas3/index.vue')
  // },
  // // 星座活動(摩羯)
  // {
  //   path: '/constellation3',
  //   name: 'Constellation3',
  //   component: () => import('./activities/constellation3/index.vue')
  // },

  // 年度盛典
  // {
  //   path: '/annual-celebration',
  //   name: 'AnnualCeletration',
  //   component: () => import('./activities/annual-celebration/index.vue')
  // },
  // // 年度盛典
  // {
  //   path: '/new-year-2024',
  //   name: 'NewYear2024',
  //   component: () => import('./activities/new-year-2024/index.vue')
  // },
  // // 聖誕節
  // {
  //   path: '/voice-room-rule',
  //   name: 'VoiceRoomRule',
  //   component: () => import('./activities/voice-room-rule/index.vue')
  // },
  // // 积分7期排名活动（浪漫同行積分賽）
  // {
  //   path: '/score-board7',
  //   name: 'Scoreboard7',
  //   component: () => import('./activities/score-board7/index.vue')
  // },
  // // 积分8期排名活动（浪漫同行積分賽2）
  // {
  //   path: '/score-board8',
  //   name: 'Scoreboard8',
  //   component: () => import('./activities/score-board8/index.vue')
  // },
  // // 开宝箱活动（欢乐日记）
  // {
  //   path: '/open-treasure-chest-diary',
  //   name: 'OpenTreasureChestDiary',
  //   component: () => import('./activities/open-treasure-chest-diary/index.vue')
  // },
  // // 星座活動(水瓶座)
  // {
  //   path: '/constellation4',
  //   name: 'Constellation4',
  //   component: () => import('./activities/constellation4/index.vue')
  // },
  // // 星空活动
  // {
  //   path: '/starry-sky',
  //   name: 'StarrySky',
  //   component: () => import('./activities/starry-sky/index.vue')
  // },
  // 糖果7期排名活动 喵喵抽奖
  // {
  //   path: '/candies-draw7',
  //   name: 'CandiesDraw7',
  //   component: () => import('./activities/candies-draw7/index.vue')
  // },
  // // 元宵节活动
  // {
  //   path: '/lantern-festival',
  //   name: 'LanternFestival',
  //   component: () => import('./activities/lantern-festival/index.vue')
  // },
  // // 星座活動(水瓶座)
  // {
  //   path: '/constellation5',
  //   name: 'Constellation5',
  //   component: () => import('./activities/constellation5/index.vue')
  // },
  // 积分9期排名活动（春日積分賽）
  // {
  //   path: '/score-board9',
  //   name: 'Scoreboard9',
  //   component: () => import('./activities/score-board9/index.vue')
  // },
  // 糖果8期抽奖活动 巧克力抽奖
  // {
  //   path: '/candies-draw8',
  //   name: 'CandiesDraw8',
  //   component: () => import('./activities/candies-draw8/index.vue')
  // },
  // 玫瑰抽奖
  // {
  //   path: '/rose-draw',
  //   name: 'RoseDraw',
  //   component: () => import('./activities/rose-draw/index.vue')
  // },
  // 星座活動(白羊座)
  // {
  //   path: '/constellation6',
  //   name: 'Constellation6',
  //   component: () => import('./activities/constellation6/index.vue')
  // },
  //开心果抽奖 愚人节活动
  // {
  //   path: '/april-fools-day',
  //   name: 'AprilFoolsDay',
  //   component: () => import('./activities/april-fools-day/index.vue')
  // },
  // 积分9期排名活动（春日積分賽）
  // {
  //   path: '/score-board10',
  //   name: 'Scoreboard10',
  //   component: () => import('./activities/score-board10/index.vue')
  // },
  // 儿童节
  // {
  //   path: '/children-day',
  //   name: 'ChildrenDay',
  //   component: () => import('./activities/children-day/index.vue')
  // },
  // 鲜花抽奖
  // {
  //   path: '/flower-draw',
  //   name: 'FlowerDraw',
  //   component: () => import('./activities/flower-draw/index.vue')
  // },
  // 星座活動(守護金牛)
  // {
  //   path: '/constellation7',
  //   name: 'Constellation7',
  //   component: () => import('./activities/constellation7/index.vue')
  // },
  // 鲜花抽奖
  // {
  //   path: '/may-day',
  //   name: 'MayDay',
  //   component: () => import('./activities/may-day/index.vue')
  // },
  // 积分11期排名活动（仲夏積分賽）
  // {
  //   path: '/score-board11',
  //   name: 'Scoreboard11',
  //   component: () => import('./activities/score-board11/index.vue')
  // },
  // 母亲节活动
  // {
  //   path: '/mother-day',
  //   name: 'MotherDay',
  //   component: () => import('./activities/mother-day/index.vue')
  // },
  // 520活动
  // {
  //   path: '/love520',
  //   name: 'Love2024',
  //   component: () => import('./activities/love-2024/index.vue')
  // },
  // 暴击宝箱活动
  {
    path: '/critical-chests',
    name: 'CriticalChests',
    component: () => import('./activities/critical-chests/index.vue')
  },
  // 屠龙活动
  // {
  //   path: '/slaying-dragons',
  //   name: 'SlayingDragons',
  //   component: () => import('./activities/slaying-dragons/index.vue')
  // },
  // 星座活動(守護双子)
  // {
  //   path: '/constellation8',
  //   name: 'Constellation8',
  //   component: () => import('./activities/constellation8/index.vue')
  // },
  // 积分12期排名活动（夏至積分賽）
  // {
  //   path: '/score-board12',
  //   name: 'Scoreboard12',
  //   component: () => import('./activities/score-board12/index.vue')
  // },
  // 端午节
  // {
  //   path: '/dragon-boat-festival',
  //   name: 'DragonBoatFestival',
  //   component: () => import('./activities/dragon-boat-festival/index.vue')
  // },
  // 寶箱送禮
  {
    path: '/treasure-chest',
    name: 'TreasureChest',
    component: () => import('./activities/treasure-chest/index.vue')
  },
  // 星座活動(守護双子)
  // {
  //   path: '/constellation9',
  //   name: 'Constellation9',
  //   component: () => import('./activities/constellation9/index.vue')
  // },
  // 积分13期排名活动（浪漫之夜積分賽）
  // {
  //   path: '/score-board13',
  //   name: 'Scoreboard13',
  //   component: () => import('./activities/score-board13/index.vue')
  // },
  // 糖果抽奖7
  // {
  //   path: '/candies-draw9',
  //   name: '/CandiesDraw9',
  //   component: () => import('./activities/candies-draw9/index.vue')
  // },
  // 星座活動(獅子座)
  // {
  //   path: '/constellation10',
  //   name: 'Constellation10',
  //   component: () => import('./activities/constellation10/index.vue')
  // },
  // 积分14期排名活动（浪漫之夜積分賽）
  // {
  //   path: '/score-board14',
  //   name: 'Scoreboard14',
  //   component: () => import('./activities/score-board14/index.vue')
  // },
  // {
  //   path: '/valentine-day-2024',
  //   name: 'ValentineDay2024',
  //   component: () => import('./activities/valentine-day-2024/index.vue')
  // },
  // 星座活動(處女座)
  // {
  //   path: '/constellation11',
  //   name: 'Constellation11',
  //   component: () => import('./activities/constellation11/index.vue')
  // },
  // 积分15期排名活动（星月積分賽）
  // {
  //   path: '/score-board15',
  //   name: 'Scoreboard15',
  //   component: () => import('./activities/score-board15/index.vue')
  // },
  // 中秋节
  // {
  //   path: '/mid-autumn-festival',
  //   name: '/midAutumnFestival',
  //   component: () => import('./activities/mid-autumn-festival/index.vue')
  // },
  // 星座活動(天秤座)
  // {
  //   path: '/constellation12',
  //   name: 'Constellation12',
  //   component: () => import('./activities/constellation12/index.vue')
  // },
  // 积分15期排名活动（星月積分賽）
  // {
  //   path: '/score-board16',
  //   name: 'Scoreboard16',
  //   component: () => import('./activities/score-board16/index.vue')
  // },
  // 糖果抽奖10
  // {
  //   path: '/candies-draw10',
  //   name: '/CandiesDraw10',
  //   component: () => import('./activities/candies-draw10/index.vue')
  // },
  // 萬聖節
  // {
  //   path: '/halloween2024',
  //   name: '/Halloween2024',
  //   component: () => import('./activities/halloween2024/index.vue')
  // },
  // 禮物更新
  // {
  //   path: '/gift-update',
  //   name: 'giftUpdate',
  //   component: () => import('./activities/gift-update/index.vue')
  // },
  // 星座活動(天秤座)
  // {
  //   path: '/constellation13',
  //   name: 'Constellation13',
  //   component: () => import('./activities/constellation13/index.vue')
  // },
  // 心动计分赛
  // {
  //   path: '/score-board17',
  //   name: 'Scoreboard17',
  //   component: () => import('./activities/score-board17/index.vue')
  // },
  // 万圣节大赛
  // {
  //   path: '/contribute-halloween',
  //   name: 'ContributeHalloween',
  //   component: () => import('./activities/contribute/index.vue')
  // },
  //投稿活動-投稿
  // {
  //   path: '/contribute-publish',
  //   name: 'ContributePublish',
  //   component: () =>
  //     import('./components/common-contribute-activity/publish.vue')
  // },
  // {
  //   path: '/contribute-publish/:type',
  //   name: 'ContributePublish',
  //   component: () =>
  //     import('./components/common-contribute-activity/publish.vue')
  // },
  // 万圣节大赛排名
  // {
  //   path: '/contribute-halloween-rank/:type',
  //   name: 'ContributeHalloweenRank',
  //   component: () => import('./activities/contribute/halloween-rank.vue')
  // },
  // 双十一
  // {
  //   path: '/double-eleven-2024',
  //   name: 'DoubleEleven2024',
  //   component: () => import('./activities/double-eleven-2024/index.vue')
  // },
  // 投稿活动-天蝎之星
  // {
  //   path: '/contribute-scorpio',
  //   name: 'ContributeScorpio',
  //   component: () => import('./activities/contribute-scorpio/index.vue')
  // },

  // // //投稿活动-天蝎之星-排名
  // {
  //   path: '/contribute-scorpio-rank/:type',
  //   name: 'ContributeScorpioRank',
  //   component: () => import('./activities/contribute-scorpio/rank.vue')
  // },
  // 投稿活动-射手之星
  // {
  //   path: '/contribute-sagittarius',
  //   name: 'ContributeSagittarius',
  //   component: () => import('./activities/contribute-sagittarius/index.vue')
  // },

  // // //投稿活动-射手之星-排名
  // {
  //   path: '/contribute-sagittarius-rank/:type',
  //   name: 'ContributeSagittariusRank',
  //   component: () => import('./activities/contribute-sagittarius/rank.vue')
  // },
  // 星座活動(射手座)
  // {
  //   path: '/constellation14',
  //   name: 'Constellation14',
  //   component: () => import('./activities/constellation14/index.vue')
  // },
  // 圣诞分赛
  // {
  //   path: '/score-board18',
  //   name: 'Scoreboard18',
  //   component: () => import('./activities/score-board18/index.vue')
  // },
  // 投稿活动-摩羯之星
  // {
  //   path: '/contribute-capricorn',
  //   name: 'ContributeCapricorn',
  //   component: () => import('./activities/contribute-capricorn/index.vue')
  // },

  // // //投稿活动-摩羯之星-排名
  // {
  //   path: '/contribute-capricorn-rank/:type',
  //   name: 'ContributeCapricornRank',
  //   component: () => import('./activities/contribute-capricorn/rank.vue')
  // },
  // 网络票选活动
  // {
  //   path: '/online-voting',
  //   name: 'onLineVoting',
  //   component: () => import('./activities/online-voting/index.vue')
  // },
  // // 圣诞节
  // {
  //   path: '/christmas2024',
  //   name: 'Christmas2024',
  //   component: () => import('./activities/christmas2024/index.vue')
  // },
  // // 星座活動(天秤座)
  // {
  //   path: '/constellation15',
  //   name: 'Constellation15',
  //   component: () => import('./activities/constellation15/index.vue')
  // },
  // //（冬夜吻玫瑰積分賽）
  // {
  //   path: '/score-board19',
  //   name: 'Scoreboard19',
  //   component: () => import('./activities/score-board19/index.vue')
  // },
  // // 投稿活动-水瓶之星
  // {
  //   path: '/contribute-aquarius',
  //   name: 'ContributeAquarius',
  //   component: () => import('./activities/contribute-aquarius/index.vue')
  // },

  // // //投稿活动-水瓶之星-排名
  // {
  //   path: '/contribute-aquarius-rank/:type',
  //   name: 'ContributeAquariusRank',
  //   component: () => import('./activities/contribute-aquarius/rank.vue')
  // },
  // // 年度盛典
  // {
  //   path: '/annual-celebration-2025',
  //   name: 'AnnualCeletration2025',
  //   component: () => import('./activities/annual-celebration-2025/index.vue')
  // },
  // 星座活動(水瓶座)
  // {
  //   path: '/constellation16',
  //   name: 'Constellation16',
  //   component: () => import('./activities/constellation16/index.vue')
  // },
  // // 红包标签活动
  // {
  //   path: '/red-envelope-2025',
  //   name: 'redEnvelope2025',
  //   component: () => import('./activities/red-envelope-2025/index.vue')
  // },
  // // 投稿活动-双鱼之星
  // {
  //   path: '/contribute-pisces',
  //   name: 'ContributePisces',
  //   component: () => import('./activities/contribute-pisces/index.vue')
  // },

  // // //投稿活动-双鱼之星-排名
  // {
  //   path: '/contribute-pisces-rank/:type',
  //   name: 'ContributePiscesRank',
  //   component: () => import('./activities/contribute-pisces/rank.vue')
  // },
  // 情人節2025
  // {
  //   path: '/valentine-day-2025',
  //   name: 'valentineDay2025',
  //   component: () => import('./activities/valentine-day-2025/index.vue')
  // },
  // 储值活动
  {
    path: '/stored-value',
    name: 'storedValue ',
    component: () => import('./activities/stored-value/index.vue')
  },
  // 告白活动
  {
    path: '/speak-now-2025',
    name: 'speakNow ',
    component: () => import('./activities/speak-now-2025/index.vue')
  },
  // 新增告白
  {
    path: '/speak-add-2025',
    name: 'speakAdd2025 ',
    component: () => import('./activities/speak-now-2025/speak-create-add.vue')
  },
  // // 投稿活动-牡羊之星
  // {
  //   path: '/contribute-aries',
  //   name: 'ContributeAries',
  //   component: () => import('./activities/contribute-aries/index.vue')
  // },

  // // //投稿活动-牧羊之星-排名
  // {
  //   path: '/contribute-aries-rank/:type',
  //   name: 'ContributeAriesRank',
  //   component: () => import('./activities/contribute-aries/rank.vue')
  // },

  // // 糖果抽奖10
  // {
  //   path: '/children-day-2025',
  //   name: '/ChildrenDay2025',
  //   component: () => import('./activities/children-day-2025/index.vue')
  // },
  // 投稿活动-金牛之星
  // {
  //   path: '/contribute-taurus',
  //   name: 'ContributeTaurus',
  //   component: () => import('./activities/contribute-taurus/index.vue')
  // },

  // // //投稿活动-金牛之星-排名
  // {
  //   path: '/contribute-taurus-rank/:type',
  //   name: 'ContributeTaurusRank',
  //   component: () => import('./activities/contribute-taurus/rank.vue')
  // },
  // 糖果抽奖11(兒童節)
  // {
  //   path: '/may-day-2025',
  //   name: '/MayDay2025',
  //   component: () => import('./activities/may-day-2025/index.vue')
  // },
  //（母亲节積分賽）
  // {
  //   path: '/score-board20',
  //   name: 'Scoreboard20',
  //   component: () => import('./activities/score-board20/index.vue')
  // },
  //（母亲节積分賽）
  // {
  //   path: '/score-board21',
  //   name: 'Scoreboard21',
  //   component: () => import('./activities/score-board21/index.vue')
  // },
  // 投稿活动-双子之星
  // {
  //   path: '/contribute-gemini',
  //   name: 'ContributeGemini',
  //   component: () => import('./activities/contribute-gemini/index.vue')
  // },

  // //投稿活动-双子之星-排名
  // {
  //   path: '/contribute-gemini-rank/:type',
  //   name: 'ContributeGeminiRank',
  //   component: () => import('./activities/contribute-gemini/rank.vue')
  // },
  // 龍舟競速賽
  // {
  //   path: '/dragon-boat-2025',
  //   name: 'dragonBoat2025 ',
  //   component: () => import('./activities/dragon-boat-2025/index.vue')
  // },
  //（666开黑节積分賽）
  // {
  //   path: '/score-board22',
  //   name: 'Scoreboard22',
  //   component: () => import('./activities/score-board22/index.vue')
  // },
  // 夏至
  // {
  //   path: '/candies-draw12',
  //   name: 'CandiesDraw12',
  //   component: () => import('./activities/candies-draw12/index.vue')
  // },
  //（666开黑节積分賽）
  // {
  //   path: '/score-board23',
  //   name: 'Scoreboard23',
  //   component: () => import('./activities/score-board23/index.vue')
  // },
  // 投稿送礼活动-巨蟹之星
  // {
  //   path: '/contribute-gift-cancer',
  //   name: 'ContributeGiftCancer',
  //   component: () => import('./activities/contribute-gift-cancer/index.vue')
  // },
  //投稿送礼活动-巨蟹之星-排名
  // {
  //   path: '/contribute-gift-rank/:type',
  //   name: 'ContributeGiftRank',
  //   component: () => import('./activities/contribute-gift-cancer/rank.vue')
  // },
  // {
  //   path: '/contribute-gift-publish/:type',
  //   name: 'ContributeGiftPublish',
  //   component: () => import('./components/contribute-gift-activity/publish.vue')
  // },
  //（聲控積分賽）
  // {
  //   path: '/score-board24',
  //   name: 'Scoreboard24',
  //   component: () => import('./activities/score-board24/index.vue')
  // },
  // 投稿送礼活动-巨蟹之星
  // {
  //   path: '/contribute-gift-leo',
  //   name: 'ContributeGiftLeo',
  //   component: () => import('./activities/contribute-gift-leo/index.vue')
  // },
  // 投稿送礼活动-巨蟹之星-排名
  // {
  //   path: '/contribute-gift-rank-leo/:type',
  //   name: 'ContributeGiftRankLeo',
  //   component: () => import('./activities/contribute-gift-leo/rank.vue')
  // },
  //LCP荣耀通行
  // {
  //   path: '/score-board25',
  //   name: 'Scoreboard25',
  //   component: () => import('./activities/score-board25/index.vue')
  // },
  // 夏至
  // {
  //   path: '/candies-draw13',
  //   name: 'CandiesDraw13',
  //   component: () => import('./activities/candies-draw13/index.vue')
  // },
  // 寻宝活动
  {
    path: '/treasure-hunt',
    name: 'TreasureHunt',
    component: () => import('./activities/treasure-hunt/index.vue')
  },
  // 七夕情人節
  // {
  //   path: '/valentine-day-qixi-2025',
  //   name: 'ValentineDayQixi2025',
  //   component: () => import('./activities/valentine-day-qixi-2025/index.vue')
  // },
  // 投稿送礼活动-處女之星
  // {
  //   path: '/contribute-gift-virgo',
  //   name: 'ContributeGiftLeo',
  //   component: () => import('./activities/contribute-gift-virgo/index.vue')
  // },
  // 投稿送礼活动-處女之星-排名
  // {
  //   path: '/contribute-gift-rank-virgo/:type',
  //   name: 'ContributeGiftRankVirgo',
  //   component: () => import('./activities/contribute-gift-virgo/rank.vue')
  // },
  // 中元節积分赛
  // {
  //   path: '/score-board26',
  //   name: 'Scoreboard26',
  //   component: () => import('./activities/score-board26/index.vue')
  // },
  // 投稿送礼活动-天平座
  // {
  //   path: '/contribute-gift-libra',
  //   name: 'ContributeGiftLeo',
  //   component: () => import('./activities/contribute-gift-libra/index.vue')
  // },
  // 投稿送礼活动-天平座-排名
  // {
  //   path: '/contribute-gift-rank-libra/:type',
  //   name: 'ContributeGiftRankLibra',
  //   component: () => import('./activities/contribute-gift-libra/rank.vue')
  // },
  // 88语音厅歌唱比赛
  // {
  //   path: '/voice-room-singing',
  //   name: 'VoiceRoomSinging',
  //   component: () => import('./activities/voice-room-singing/index.vue')
  // },
  // 双十节
  // {
  //   path: '/double-tenth-day',
  //   name: 'DoubleTenthDay',
  //   component: () => import('./activities/double-tenth-day/index.vue')
  // },
  // 萬聖節 
  // {
  //   path: '/halloween2025',
  //   name: 'Halloween2025',
  //   component: () => import('./activities/halloween2025/index.vue')
  // },
  // 88语音厅歌唱比赛
  // {
  //   path: '/voice-room-singing2',
  //   name: 'VoiceRoomSinging2',
  //   component: () => import('./activities/voice-room-singing2/index.vue')
  // },
  // 巔峰盛典-急速奪寶活動
  // {
  //   path: '/peak-speed-treasure',
  //   name: 'PeakSpeedTreasure',
  //   component: () => import('./activities/peak-speed-treasure/index.vue')
  // },
  // 大神活動
  // {
  //   path: '/master-activity',
  //   name: 'MasterActivity',
  //   component: () => import('./activities/master-activity/index.vue')
  // },
  //圣诞节2025
  // {
  //   path: '/christmas2025',
  //   name: 'Christmas2025',
  //   component: () => import('./activities/christmas2025/index.vue')
  // },
  //元旦活动2026
  // {
  //   path: '/newyear2026',
  //   name: 'NewYear2026',
  //   component: () => import('./activities/newyear2026/index.vue')
  // },
  //年度活动
  // {
  //   path: '/annual-activity',
  //   name: 'AnnualActivity',
  //   component: () => import('./activities/annual-activity/index.vue')
  // },
  //歌手认证比赛
  // {
  //   path: '/voice-room-singing',
  //   name: 'VoiceRoomSinging',
  //   component: () => import('./activities/voice-room-singing/index.vue')
  // },
  // 情人節活動 2026
  // {
  //   path: '/valentine-2026',
  //   name: 'Valentine2026',
  //   component: () => import('./activities/valentine-2026/index.vue')
  // },
  // // 大神活動 2026（工作室上分）
  // {
  //   path: '/studio-rank-2026',
  //   name: 'StudioRank2026',
  //   component: () => import('./activities/studio-rank-2026/index.vue')
  // },
  // // 星座活動 2026
  {
    path: '/constellation2026',
    name: 'Constellation2026',
    component: () => import('./activities/constellation2026/index.vue')
  },
  // // 春節活動 2026
  // {
  //   path: '/spring-festival-2026',
  //   name: 'SpringFestival2026',
  //   component: () => import('./activities/spring-festival-2026/index.vue')
  // },
  // // 女神節活動 2026
  // {
  //   path: '/nvshenjie-2026',
  //   name: 'Nvshenjie2026',
  //   component: () => import('./activities/nvshenjie-2026/index.vue')
  // },
  // 愚人節活動 2026
  // {
  //   path: '/yurenjie-2026',
  //   name: 'Yurenjie2026',
  //   component: () => import('./activities/yurenjie-2026/index.vue')
  // },
  // // 兒童節活動 2026
  // {
  //   path: '/ertongjie-2026',
  //   name: 'Ertongjie2026',
  //   component: () => import('./activities/ertongjie-2026/index.vue')
  // },
  // 連續消費調賬
  {
    path: '/challenge-activity',
    name: 'ChallengeActivity',
    component: () => import('./activities/challenge/index.vue')
  },
  // 五一劳动节接单赛
  {
    path: '/mayday-2026',
    name: 'Mayday2026',
    component: () => import('./activities/may-day-2026/index.vue')
  },
  // 母親節活動 2026
  {
    path: '/mother-day-2026',
    name: 'MotherDay2026',
    component: () => import('./activities/mother-day-2026/index.vue')
  },
  // 簽到領好禮活動
  {
    path: '/daily-rewards',
    name: 'DailyRewards',
    component: () => import('./activities/daily-rewards/index.vue')
  },
  // 老用戶回歸活動
  {
    path: '/welcome-back-old',
    name: 'WelcomeBack',
    component: () => import('./activities/welcome-back/index.vue')
  },
  // 老用戶回歸活動 v2
  {
    path: '/welcome-back',
    name: 'WelcomeBackV2',
    component: () => import('./activities/welcome-back-v2/index.vue')
  },
  // 全新用戶回歸專屬大禮包活動
  {
    path: '/new-user-gift',
    name: 'NewUserGift',
    component: () => import('./activities/feature-new-user-gift/index.vue')
  },
  // 520 CP 積分排行 2026
  {
    path: '/love520-2026',
    name: 'Love5202026',
    component: () => import('./activities/love520-2026/index.vue')
  },
  // 心動積分賽 2026
  {
    path: '/score-board-2026',
    name: 'ScoreBoard2026',
    component: () => import('./activities/score-board-2026/index.vue')
  },
  // 星座守護計劃
  {
    path: '/zodiac-guardian-plan',
    name: 'ZodiacGuardianPlan',
    component: () => import('./activities/zodiac-guardian-plan/index.vue')
  },
  // 新手挑戰任務
  {
    path: '/newcomer-challenge-mission',
    name: 'NewcomerChallengeMission',
    component: () => import('./activities/newcomer-challenge-mission/index.vue')
  },
  // 夏日好友召集令
  {
    path: '/friend-invite',
    name: 'FriendInvite',
    component: () => import('./activities/friend-invite/index.vue')
  },
  // 父親節限定寵愛計畫
  {
    path: '/fathers-day',
    name: 'FathersDay',
    component: () => import('./activities/fathers-day/index.vue')
  },
  // 固陪再次下單計畫
  {
    path: '/companion-repurchase',
    name: 'CompanionRepurchase',
    component: () => import('./activities/companion-repurchase/index.vue')
  },
  // 七夕心動儲值祭 2026
  {
    path: '/qixi2026',
    name: 'Qixi2026',
    component: () => import('./activities/qixi2026/index.vue')
  },
  // 幸運刮刮樂
  {
    path: '/scratch-card',
    name: 'ScratchCard',
    component: () => import('./activities/scratch-card/index.vue')
  },
  // 擲筊求好運
  {
    path: '/poe-game',
    name: 'PoeGame',
    component: () => import('./activities/poe-game/index.vue')
  },
  // 站隊大戰
  {
    path: '/team-vs',
    name: 'TeamVs',
    component: () => import('./activities/team-vs/index.vue')
  },
  // 命定抽卡
  {
    path: '/fated-draw',
    name: 'FatedDraw',
    component: () => import('./activities/fated-draw/index.vue')
  },
  // 命定抽卡－今日緣分
  {
    path: '/fated-draw/matches',
    name: 'FatedDrawMatches',
    component: () => import('./activities/fated-draw/match-list.vue')
  },
  // 星空尋寶
  {
    path: '/stellar-quest',
    name: 'StellarQuest',
    component: () => import('./activities/stellar-quest/index.vue')
  },
  // 復購寵愛
  {
    path: '/repurchase-love',
    name: 'RepurchaseLove',
    component: () => import('./activities/repurchase-love/index.vue')
  },
  // 萬聖搗蛋鬼・糖果大作戰
  {
    path: '/halloween-candy-draw',
    name: 'HalloweenCandyDraw',
    component: () => import('./activities/halloween-candy-draw/index.vue')
  }
];
export default routers;
